import React from "react";

export const Events = (props) => {
  const getRegistrationSubject = (title) => {
    if (title.includes("II")) {
      return "Anmeldung Bildungsreise II";
    } else if (title.includes("I")) {
      return "Anmeldung Bildungsreise I";
    }
    return "";
  };

  return (
    <div id="events">
      <div className="container">
        <div className="section-title">
          <h2>TERMINE UND VERANSTALTUNGEN</h2>
          <p>
            Aktuelle Ausstellungen, Vorträge und Veranstaltungen rund um Tommy Fritta-Haas.
          </p>
        </div>
        <div className="row">
          <div className="col-xs-12">
            {props.data ? (
              <div className="events-list">
                {props.data.map((event, i) => (
                  <div key={`event-${i}`} className="event-item">
                    {event.image && (
                      <div className="event-image">
                        <img src={event.image} alt={event.title} className="img-responsive" />
                      </div>
                    )}
                    <h3>{event.title}</h3>
                    <p className="event-date">{event.date}</p>
                    <p className="event-description">{event.description}</p>
                    <div className="event-links">
                      {event.link && (
                        <a href={event.link} className="btn btn-custom" target="_blank" rel="noopener noreferrer">
                          Mehr Informationen
                        </a>
                      )}
                      {event.downloadLink && (
                        <a href={event.downloadLink} className="btn btn-custom" download>
                          PDF herunterladen
                        </a>
                      )}
                      {event.title.includes("Bildungsreise") && (
                        <a 
                          href={`mailto:david-haas1@gmx.de?subject=${encodeURIComponent(getRegistrationSubject(event.title))}`} 
                          className="btn btn-custom"
                        >
                          Anmeldung
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>Loading events...</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}; 